// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_features_dashboard_dashboard_module_ts":"9312f3d05ec8987e","src_app_features_dashboard_orders_orders_module_ts":"9f826800ea58b560"}[chunkId] + ".js";
};